import { render, staticRenderFns } from "./WithdrawalAdmin.vue?vue&type=template&id=f10367ce&"
import script from "./WithdrawalAdmin.vue?vue&type=script&lang=js&"
export * from "./WithdrawalAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports